module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Up-left-f474bdba403fbbb6c7a3f7b8b80df8ea.svg";